import { Payment, Provider, Video, VisitEvent } from './';

export interface VisitDetail {
  communicationPlatform: 'twilio' | 'daily' | null;
  communicationType: VisitMethod;
  visitId: string;
  visitType: {
    id: string;
    name: string;
  };
  method: VisitMethod;
  dateTime: string;
  isPast: boolean;
  isCheckedIn: boolean;
  isStarted: boolean;
  isCancelled: boolean;
  isScheduledByAdmin: boolean;
  isReferralAllowed: boolean;
  isRescheduled: boolean;
  isPriceChanged: boolean;
  payment: Payment;
  provider: Provider;
  prescriptionSummary: {
    count: number;
  };
  referralCreditAmount: number;
  visitNoteSummary: {
    count: number;
  };
  instructionSummary: {
    count: number;
  };
  events: VisitEvent[];
  video: Video | null;
  intakeForm: {
    intakeFormId: string;
    isCompleted: boolean;
  } | null;
  hasRating: boolean;
}

export interface UpcomingVisit {
  dateTime: string; // ISO 8601 format
  isCheckedIn: boolean;
  intakeForm: {
    intakeFormId: string;
    isCompleted: boolean;
  };
  lastEvent: {
    dateTime: string; // ISO 8601 format
    type: string;
  };
  method: VisitMethod;
  provider: Provider;
  video: {
    accessToken: string;
    roomName: string;
    videoCallId: string;
  };
  visitId: string;
  visitTypeName: string;
}

export enum VisitMethod {
  CALL = 'call',
  VIDEO = 'video',
  INPERSON = 'inperson',
}
